import { IconProps } from './types';

export const IconClose = ({ height = '16', width = '16', ...props }: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.29289 3.70711C1.90237 3.31658 1.90237 2.68342 2.29289 2.29289C2.68342 1.90237 3.31658 1.90237 3.70711 2.29289L7.99925 6.58503L12.2914 2.29289C12.6819 1.90237 13.3151 1.90237 13.7056 2.29289C14.0961 2.68342 14.0961 3.31658 13.7056 3.70711L9.41346 7.99925L13.7046 12.2904C14.0951 12.6809 14.0951 13.314 13.7046 13.7046C13.314 14.0951 12.6809 14.0951 12.2904 13.7046L7.99925 9.41346L3.70813 13.7046C3.31761 14.0951 2.68444 14.0951 2.29392 13.7046C1.9034 13.314 1.9034 12.6809 2.29392 12.2904L6.58503 7.99925L2.29289 3.70711Z"
                fill="currentColor"
            />
        </svg>
    );
};
